import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { filter, Observable, Subscription } from 'rxjs';
import { ShopCategory } from '../../models/shop-category.interface';

@Component({
    selector: 'app-category-filter',
    templateUrl: './category-filter.component.html',
    styleUrls: ['./category-filter.component.scss'],
})
export class CategoryFilterComponent implements OnInit, OnDestroy {
    @Input() allText = 'ALL';
    @Input() title: string = 'Stores';
    @Input() categories: ShopCategory[] = [];
    @Input() activeFilter: Observable<string> | null = null;
    @Output() categoryClicked: EventEmitter<string> = new EventEmitter();

    activeCategory = this.allText;
    private activeFilterSubscription: Subscription | null = null;

    ngOnInit(): void {
        if (this.activeFilter == null) {
            throw new Error('Active filter is not set');
        }
        this.activeFilterSubscription = this.activeFilter
            .pipe(filter((categoryFilter) => categoryFilter != null))
            .subscribe((categoryFilter) => {
                this.activeCategory = categoryFilter;
            });
    }

    ngOnDestroy(): void {
        if (this.activeFilterSubscription != null) {
            this.activeFilterSubscription.unsubscribe();
        }
    }

    onCategoryClick(categoryId: string): void {
        this.categoryClicked.emit(categoryId);
    }
}
